import React, { ReactNode } from 'react';

export interface AttributeListItemProps {
  label: string;
  children: ReactNode;
}

const AttributeListItem: React.FC<AttributeListItemProps> = ({ children, label }) => (
  <tr>
    <th>
      <label>{label}</label>
    </th>
    <td>{children}</td>
  </tr>
);

export default AttributeListItem;
